import { createReducer } from 'reduxsauce';
import { produce } from 'immer';
import { clone, concat, filter, find, findIndex, isNil, prop, propEq, sortBy, values } from 'ramda';
import moment from 'moment';
import { ManageTypes } from '~/actions';
import { removeStatus } from '~/services/util';

const initialState = {
    status: [],
    tasksData: { tasksCard: { data: [] }, statsCard: { data: [] }, habitsCard: [] },
    tasksReport: { companies: [], individuals: [], totals: {} },
    projects: [],
    companyProjects: [],
    currentUsers: [],
    selectedProject: {},
    selectedProjectTasks: { tasks: [], habits: [] },
    selectedProjectCompletedTasks: { tasks: [], habits: [] },

    projectTasks: [],
    currentProject: null,

    companyCareers: [],

    companyPerformanceReviews: {
        page: 1,
        last_page: 1,
        order: 'name',
        sort: 'ASC',
        users: [],
        stats: {
            employees: { count: 0 },
            actuals_saved: { count: 0, percent: 0 },
            reviews_completed: { count: 0, percent: 0 },
            scorecards: { count: 0, percent: 0 },
        },
        departments: [],
    },
    companyDailyCheckouts: {
        page: 1,
        last_page: 1,
        order: 'name',
        sort: 'ASC',
        users: [],
        stats: {
            employees: { count: 0 },
            actuals_saved: { count: 0, percent: 0 },
            reviews_completed: { count: 0, percent: 0 },
            scorecards: { count: 0, percent: 0 },
        },
        departments: [],
    },
    individualPerformanceReview: { performance: { trainings: [], tasks: [] }, scorecards: [] },
    performanceReviews: { current_page: 1, data: [], last_page: 1, per_page: 10, total: 1 },
    previousReviews: { tasks: [], trainings: [] },
    companyorgChart: { departments: {} },
    saveactualsReport: { companies: {}, totals: {}, users: [] },
    engagementReport: {
        trainings: [],
        newhires: [],
        performances: [],
        tasks: [],
        careers: [],
        records: [],
        users: [],
        totals: [],
    },
    certificationsReport: {
        type: 'employees',
        users: [],
        programs: [],
        page: 1,
        per_page: 20,
        last_page: 1,
        total: 1,
    },
    careerReport: {
        type: 'employees',
        users: [],
        programs: [],
        page: 1,
        per_page: 20,
        last_page: 1,
        total: 1,
    },
    newHireReport: {
        companies: {},
        individuals: {},
        totals: {
            certifications_assigned: 0,
            certifications_authored: 0,
            certifications_completed: 0,
            new_hires: 0,
        },
    },
    managerDashboard: {
        user_list: '',
        career: { average_completion: 0, employee_careers: 0, promotions_possible: 0, top_users: [] },
        employee_records: {
            active_signed_documents: 'N/A',
            average_performance: 0,
            employee_careers: 0,
            habit_schedules: 0,
            new_hires: 0,
            scorecards: 0,
            tasks_assigned: 0,
            total_employees: 0,
            training_assigned: 0,
        },
        new_hire: {
            certifications_assigned: 0,
            certifications_completed: 0,
            new_hires: 0,
            top_users: [],
        },
        performance: {
            average_reviews: 0,
            scorecards: 0,
            task_commitments: 0,
            top_users: [],
            training_commitments: 0,
        },
        tasks: {
            active_projects: 0,
            habits_completed: 0,
            popular_projects: [],
            tasks_completed: 0,
            top_users: [],
        },
        training: { assignments: 'Yes', courses_completed: 0, modules_completed: 0, top_users: [] },
        users: [],
    },
    anniversarybirthdayReport: { active: {}, prior: {}, recruit: {} },

    trainingReports: {
        company: {
            overall: {},
            career: {},
            manager: {},
            self: {},
            companies: [],
            page: 1,
            per_page: 25,
            last_page: 1,
            from: 1,
            to: 1,
            total: 1,
        },
        individual: {
            overall: {},
            career: {},
            manager: {},
            self: {},
            individuals: [],
            page: 1,
            per_page: 25,
            last_page: 1,
            from: 1,
            to: 1,
            total: 1,
        },
    },
    quotaReports: { quota_templates: [] },
    trainingCompetencyReport: { process: {}, skills: {}, product_knowledge: {}, temperament: {} },
    individualQuotaReport: {
        current_page: 1,
        employee_name: '',
        quota_data: {},
        per_page: 25,
        last_page: 1,
        from: 1,
        to: 1,
        total: 1,
    },
    trainingTrackReport: { totals: {}, individuals: [], tracks: [] },
    trainingTrackDetailReport: { users: [], track: [] },
    teamActivityReport: {
        company_name: '',
        company_logo: '',
        total_users: 0,
        active_employees: 0,
        course_module_completed: 0,
        course_completed: 0,
        course_due: 0,
        modules_completed: 0,
        modules_due: 0,
        active_learner: [],
        task_completed: 0,
        task_due: 0,
        habbit_completed: 0,
        habbit_due: 0,
        heighest_task_completer: [],
    },

    dailyFeed: {
        all: [],
        month: [],
        today: [],
        week: [],
        daily_scorecard: {},
    },
    dailyCheckout: {
        checkout: {},
        daily_scorecard: {},
        monthly_scorecard: {},
    },
};

/**
 * GET Career Program
 * @param {*} draft
 * @param {*} action
 */
const getcareerprogramRequest = produce((draft, action) => {
    draft.status.push('pending-mgc');
});
const getcareerprogramSuccess = produce((draft, action) => {
    const { program, profile } = action.response;

    if (program.type == 1) {
        // program career
        const pindex = findIndex(propEq('id', program.id), draft.careerReport.programs);

        if (pindex > -1) {
            draft.careerReport.programs[pindex] = program;
        } else {
            draft.careerReport.programs = concat(draft.careerReport.programs, [program]);
        }

        if (!isNil(program.user_id)) {
            const uindex = findIndex(propEq('id', program.user_id), draft.careerReport.users);
            if (uindex > -1) {
                const cindex = findIndex((e) => e.id === program.id, draft.careerReport.users[uindex].stats.open_careers);
                if (cindex > -1) {
                    draft.careerReport.users[uindex].stats.open_careers[cindex] = program;
                } else {
                    draft.careerReport.users[uindex].stats.open_careers = concat(draft.careerReport.users[uindex].stats.open_careers, [program]);
                }
            } else {
                draft.careerReport.users = concat(draft.careerReport.users, [
                    {
                        id: program.user_id,
                        profile,
                        stats: { open_careers: [program] },
                    },
                ]);
            }
        }
    } else if (program.type == 2) {
        const pindex = findIndex(propEq('id', program.id), draft.certificationsReport.programs);

        if (pindex > -1) {
            draft.certificationsReport.programs[pindex] = program;
        } else {
            draft.certificationsReport.programs = concat(draft.certificationsReport.programs, [program]);
        }

        if (!isNil(program.user_id)) {
            const uindex = findIndex(propEq('id', program.user_id), draft.certificationsReport.users);
            if (uindex > -1) {
                const cindex = findIndex((e) => e.id === program.id, draft.certificationsReport.users[uindex].stats.open_certifications);
                if (cindex > -1) {
                    draft.certificationsReport.users[uindex].stats.open_certifications[cindex] = program;
                } else {
                    draft.certificationsReport.users[uindex].stats.open_certifications = concat(draft.certificationsReport.users[uindex].stats.open_certifications, [program]);
                }
            } else {
                draft.certificationsReport.users = concat(draft.certificationsReport.users, [
                    {
                        id: program.user_id,
                        profile,
                        stats: { open_certifications: [program] },
                    },
                ]);
            }
        }
    }
    draft.status = removeStatus('pending-mgc', draft.status);
});
const getcareerprogramFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mgc', draft.status);
});

const postcareerprogramRequest = produce((draft, action) => {
    draft.status.push('pending-mpc');
});
const postcareerprogramSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mpc', draft.status);
});
const postcareerprogramFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mpc', draft.status);
});

const gettasksfeedRequest = produce((draft, action) => {
    draft.status.push('pending-mft');
});
const gettasksfeedSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mft', draft.status);
    draft.tasksData = action.response;
});
const gettasksfeedFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mft', draft.status);
});

const companyprojectsRequest = produce((draft, action) => {
    draft.status.push('pending-mcp');
});
const companyprojectsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mcp', draft.status);
    draft.companyProjects = action.response;
});
const companyprojectsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mcp', draft.status);
});

const selectprojectRequest = produce((draft, action) => {
    draft.status.push('pending-msp');
});
const selectprojectSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-msp', draft.status);
    draft.selectedProject = action.response;
});
const selectprojectFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-msp', draft.status);
});

const userprojecttaskRequest = produce((draft, action) => {
    draft.status.push('pending-mup');
});
const userprojecttaskSuccess = produce((draft, action) => {
    const { completionType, tasks, habits } = action.response;
    draft.status = removeStatus('pending-mup', draft.status);
    if (isNil(completionType)) {
        draft.selectedProjectTasks = { tasks, habits };
    } else {
        draft.selectedProjectCompletedTasks = { tasks, habits };
    }
});
const userprojecttaskFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mup', draft.status);
});

// Update Task Card Event
const updatetaskRequest = produce((draft, action) => {
    draft.status.push('pending-mut');
});
const updatetaskSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mut', draft.status);
    const { event, cardId } = action.response;
    const status = event === 'completed' ? 3 : 0;
    const completed_at = event === 'completed' ? moment(new Date()).format('YYYY-MM-DD hh:mm:ss') : null;
    const tIndex = findIndex(propEq('id', cardId), draft.selectedProjectTasks.tasks);
    const hIndex = findIndex(propEq('id', cardId), draft.selectedProjectTasks.habits);
    const type = tIndex > -1 ? 'tasks' : 'habits';
    if (tIndex > -1 || hIndex > -1) {
        const index = tIndex > -1 ? tIndex : hIndex;
        draft.selectedProjectTasks[type][index].status = status;
        draft.selectedProjectTasks[type][index].completed_at = completed_at;
        draft.selectedProjectTasks[type][index].viewed = 1;
    }
    const taskIdx = findIndex(propEq('id', cardId), draft.tasksData.tasksCard.data);
    const habitIdx = findIndex(propEq('id', cardId), draft.tasksData.habitsCard);
    if (taskIdx > -1) {
        draft.tasksData.tasksCard.data[taskIdx].status = status;
        draft.tasksData.tasksCard.data[taskIdx].completed_at = completed_at;
        draft.tasksData.tasksCard.data[taskIdx].viewed = 1;
    }
    if (habitIdx > -1) {
        draft.tasksData.habitsCard[habitIdx].status = status;
        draft.tasksData.habitsCard[habitIdx].completed_at = completed_at;
        draft.tasksData.habitsCard[habitIdx].viewed = 1;
    }

    const pIndex = findIndex(propEq('id', cardId), draft.individualPerformanceReview.performance?.tasks || []);
    if (pIndex > -1) {
        draft.individualPerformanceReview.performance.tasks[pIndex].status = status;
        draft.individualPerformanceReview.performance.tasks[pIndex].completed_at = completed_at;
    }

    for (let idx = 0; idx < draft.individualPerformanceReview.performance?.trainings?.length; idx++) {
        let training = clone(draft.individualPerformanceReview.performance?.trainings[idx]);
        const rIndex = findIndex(propEq('id', cardId), training.children || []);
        if (rIndex > -1) {
            draft.individualPerformanceReview.performance.trainings[idx].children[rIndex].status = status;
            draft.individualPerformanceReview.performance.trainings[idx].children[rIndex].completed_at = completed_at;
            let completed = true;
            training = clone(draft.individualPerformanceReview.performance?.trainings[idx]);
            for (let ci = 0; ci < training?.children?.length; ci++) {
                completed = completed && training.children[ci].status === 3;
            }
            if (completed) {
                draft.individualPerformanceReview.performance.trainings[idx].status = status;
                draft.individualPerformanceReview.performance.trainings[idx].completed_at = completed_at;
            }
        }
    }
});
const updatetaskFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mut', draft.status);
});

// Edit Card
const edittaskRequest = produce((draft, action) => {
    draft.status.push('pending-met');
});
const edittaskSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-met', draft.status);
});
const edittaskFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-met', draft.status);
});

// Delete Card
const deletetaskRequest = produce((draft, action) => {
    draft.status.push('pending-mde');
});
const deletetaskSuccess = produce((draft, action) => {
    const task = action.response;
    const tasks = filter((x) => x.id !== task.id, draft.selectedProjectTasks.tasks);
    const habits = filter((x) => x.id !== task.id, draft.selectedProjectTasks.habits);
    const habitsCard = filter((x) => x.id !== task.id, draft.tasksData.habitsCard);
    const tasksData = filter((x) => x.id !== task.id, draft.tasksData.tasksCard.data);
    draft.selectedProjectTasks = { tasks, habits };
    draft.tasksData = {
        ...draft.tasksData,
        habitsCard,
        tasksCard: { ...draft.tasksData.tasksCard, data: tasksData },
    };
    draft.status = removeStatus('pending-mde', draft.status);
});
const deletetaskFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mde', draft.status);
});

// Retrieving TaskDetail
const fetchtaskdetailRequest = produce((draft, action) => {
    draft.status.push('pending-mfa');
});
const fetchtaskdetailSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mfa', draft.status);
});
const fetchtaskdetailFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mfa', draft.status);
});

// Add Comment
const addmngcommentRequest = produce((draft, action) => {
    draft.status.push('pending-mac');
});
const addmngcommentSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mac', draft.status);
});
const addmngcommentFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mac', draft.status);
});

// Adding Taks
const addtaskRequest = produce((draft, action) => {
    draft.status.push('pending-maa');
});
const addtaskSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-maa', draft.status);
});
const addtaskFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-maa', draft.status);
});

const searchmodulesRequest = produce((draft, action) => {
    draft.status.push('pending-msm');
});
const searchmodulesSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-msm', draft.status);
});
const searchmodulesFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-msm', draft.status);
});

// Assign Training
const assigntrainingRequest = produce((draft, action) => {
    draft.status.push('pending-mai');
});
const assigntrainingSuccess = produce((draft, action) => {
    const { target, response: data } = action;
    if (target === 'scorecards') {
        data.forEach((item) => {
            const companyPerformanceReviewsIndex = findIndex((e) => e.user.id === item.user_id, draft.companyPerformanceReviews.users);
            if (companyPerformanceReviewsIndex > -1) {
                draft.companyPerformanceReviews.users[companyPerformanceReviewsIndex].scorecards.push(item);
            }
            const companyDailyCheckoutsIndex = findIndex((e) => e.user.id === item.user_id, draft.companyDailyCheckouts.users);
            if (companyDailyCheckoutsIndex > -1 && item?.type === 0) {
                draft.companyDailyCheckouts.users[companyDailyCheckoutsIndex].daily_scorecard = item;
            }
            const checkoutActualsIndex = findIndex((e) => e.id === item.user_id, draft.checkoutActuals.users);
            if (checkoutActualsIndex > -1 && item?.type === 0) {
                draft.checkoutActuals.users[checkoutActualsIndex].checkout.scorecard = item;
            }
        });
    }
    draft.status = removeStatus('pending-mai', draft.status);
});
const assigntrainingFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mai', draft.status);
});

const assigncoursesRequest = produce((draft, action) => {
    draft.status.push('pending-mag');
});
const assigncoursesSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mag', draft.status);
});
const assigncoursesFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mag', draft.status);
});

// Unassined content
const unassigncontentRequest = produce((draft, action) => {
    draft.status.push('pending-mue');
});
const unassigncontentSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mue', draft.status);
});
const unassigncontentFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mue', draft.status);
});

//Add project
const addprojectRequest = produce((draft, action) => {
    draft.status.push('pending-mao');
});
const addprojectSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mao', draft.status);
    const { id, name, company_id, data } = action.response;
    const project = {
        company_id,
        id,
        data,
        deleted_at: null,
        users: data?.users?.map((item) => ({ id: item, name: '' })),
        name,
        task_stats: { complete: 0, mtd_completion: 0, open: 0, past_due: 0, total: 0 },
    };
    draft.companyProjects.push(project);
});
const addprojectFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mao', draft.status);
});

// Update Project
const updateprojectRequest = produce((draft, action) => {
    draft.status.push('pending-muj');
});
const updateprojectSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-muj', draft.status);
});
const updateprojectFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-muj', draft.status);
});

// Delete Project
const deleteprojectRequest = produce((draft, action) => {
    draft.status.push('pending-mdo');
});
const deleteprojectSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mdo', draft.status);
});
const deleteprojectFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mdo', draft.status);
});

// Projects Page
const fetchprojectsdetailRequest = produce((draft, action) => {
    draft.status.push('pending-mfs');
});
const fetchprojectsdetailSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mfs', draft.status);
    draft.projectTasks = action.response;
});
const fetchprojectsdetailFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mfs', draft.status);
});
const fetchprojectdetailComplete = produce((draft, action) => {
    draft.status = removeStatus('pending-mfs', draft.status);
});

const companyindividualRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) draft.status.push('pending-mci');
});
const companyindividualSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mci', draft.status);
    draft.tasksReport = action.response;
});
const companyindividualFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mci', draft.status);
});

// Engagement Report
const fetchengagementreportRequest = produce((draft, action) => {
    draft.status.push('pending-mfr');
});
const fetchengagementreportSuccess = produce((draft, action) => {
    const { companies, individuals, by, type, totals } = action.response;
    draft.engagementReport[type] = by === 'company' ? companies : individuals;
    draft.engagementReport['totals'] = totals;
    draft.status = removeStatus('pending-mfr', draft.status);
});
const fetchengagementreportFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mfr', draft.status);
});

// Certifications Report
const fetchcertificationsreportRequest = produce((draft, action) => {
    draft.status.push('pending-mfi');
});
const fetchcertificationsreportSuccess = produce((draft, action) => {
    const { type, data } = action.response;
    draft.certificationsReport.type = type;
    draft.certificationsReport.last_page = data.last_page;
    draft.certificationsReport.total = data.total;
    if (type == 'employees') {
        draft.certificationsReport.users = data.users;
    } else {
        draft.certificationsReport.programs = data.programs;
    }
    draft.status = removeStatus('pending-mfi', draft.status);
});
const fetchcertificationsreportFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mfi', draft.status);
});

// Career Report
const fetchcareerreportsRequest = produce((draft, action) => {
    draft.status.push('pending-mfg');
});
const fetchcareerreportsSuccess = produce((draft, action) => {
    const { type, data } = action.response;
    draft.careerReport.type = type;
    draft.careerReport.from = data.from;
    draft.careerReport.last_page = data.last_page;
    draft.careerReport.page = data.page;
    draft.careerReport.per_page = data.per_page;
    draft.careerReport.to = data.to;
    draft.careerReport.total = data.total;
    if (data.users) draft.careerReport.users = data.users;
    if (data.programs) draft.careerReport.programs = data.programs;
    draft.status = removeStatus('pending-mfg', draft.status);
});
const fetchcareerreportsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mfg', draft.status);
});

const fetchhireorientationreportRequest = produce((draft, action) => {
    draft.status.push('pending-mfz');
});
const fetchhireorientationreportSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mfz', draft.status);
    draft.newHireReport = action.response;
});
const fetchhireorientationreportFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mfz', draft.status);
});

const fetchcompanycareersRequest = produce((draft, action) => {
    draft.status.push('pending-mfq');
});
const fetchcompanycareersSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mfq', draft.status);
    draft.companyCareers = action.response;
});
const fetchcompanycareersFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mfq', draft.status);
});

const companyperformancereviewsRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) {
        draft.status.push('pending-mco');
    }
});
const companyperformancereviewsSuccess = produce((draft, action) => {
    const { last_page, order, page, per_page, sort, users, total } = action.response;
    draft.status = removeStatus('pending-mco', draft.status);
    draft.companyPerformanceReviews.last_page = last_page;
    draft.companyPerformanceReviews.order = order;
    draft.companyPerformanceReviews.page = page;
    draft.companyPerformanceReviews.per_page = per_page;
    draft.companyPerformanceReviews.sort = sort;
    draft.companyPerformanceReviews.users = users;
    draft.companyPerformanceReviews.total = total;
});
const companyperformancereviewsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mco', draft.status);
});

const companyperformancereviewsstatsRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) {
        draft.status.push('pending-mcrs');
    }
});
const companyperformancereviewsstatsSuccess = produce((draft, action) => {
    const { stats, departments } = action.response;
    draft.companyPerformanceReviews.stats = stats;
    draft.companyPerformanceReviews.departments = departments;
    draft.status = removeStatus('pending-mcrs', draft.status);
});
const companyperformancereviewsstatsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mcrs', draft.status);
});

const companydailycheckoutsRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) {
        draft.status.push('pending-mcdc');
    }
});
const companydailycheckoutsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mcdc', draft.status);
    draft.companyDailyCheckouts = action.response;
});
const companydailycheckoutsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mcdc', draft.status);
});

const getcompanycheckoutsRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) {
        draft.status.push('pending-gcc');
    }
});

const getcompanycheckoutsSuccess = produce((draft, action) => {
    draft.companyCheckouts = action.response;
    draft.status = removeStatus('pending-gcc', draft.status);
});

const getcompanycheckoutsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-gcc', draft.status);
});

const individualperformancereviewRequest = produce((draft, action) => {
    draft.status.push('pending-mip');
});
const individualperformancereviewSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mip', draft.status);
    draft.individualPerformanceReview = action.response;
});
const individualperformancereviewFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mip', draft.status);
});

const postperformancereviewRequest = produce((draft, action) => {
    draft.status.push('pending-mpp');
});
const postperformancereviewSuccess = produce((draft, action) => {
    const { performance } = action.response;
    draft.individualPerformanceReview.performance.data = performance.data;
    draft.individualPerformanceReview.performance.updated_at = performance.updated_at;
    const index = findIndex((e) => e.performance && e.performance.id == performance.id, draft.companyPerformanceReviews.users);
    if (index > -1) {
        draft.companyPerformanceReviews.users[index].performance = {
            ...draft.companyPerformanceReviews.users[index].performance,
            ...performance,
        };
    }
    draft.status = removeStatus('pending-mpp', draft.status);
});
const postperformancereviewFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mpp', draft.status);
});

const postperformancereviewresetRequest = produce((draft, action) => {
    draft.status.push('pending-prr');
});
const postperformancereviewresetSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-prr', draft.status);
});
const postperformancereviewresetFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-prr', draft.status);
});

const getperformancereviewsRequest = produce((draft, action) => {
    draft.status.push('pending-mgp');
});
const getperformancereviewsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mgp', draft.status);
    draft.performanceReviews = action.response;
});
const getperformancereviewsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mgp', draft.status);
});

const getpreviousreviewtasksRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) draft.status.push('pending-mgr');
});
const getpreviousreviewtasksSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mgr', draft.status);
    draft.previousReviews = action.response;
});
const getpreviousreviewtasksFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mgr', draft.status);
});

const getmanagerdashboardRequest = produce((draft, action) => {
    draft.status.push('pending-mgm');
});
const getmanagerdashboardSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mgm', draft.status);
    draft.managerDashboard = action.response;
});
const getmanagerdashboardFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mgm', draft.status);
});

const postquotaactualsRequest = produce((draft, action) => {
    draft.status.push('pending-mpq');
});
const postquotaactualsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mpq', draft.status);
    if (draft.individualPerformanceReview?.scorecards[0]?.quotas) {
        const { id, response } = action;
        const commentedQuota = clone(draft.individualPerformanceReview.scorecards[0].quotas);
        const idx1 = findIndex(propEq('id', response[0].quota_id), commentedQuota);
        if (idx1 > -1) {
            draft.individualPerformanceReview.scorecards[0].quotas[idx1].actuals[0] = response[0];
        }
        if (draft?.companyPerformanceReviews?.users[0]?.scorecard?.length > 0) {
            const uIndex = findIndex((e) => e.user.id === id.user_id, draft.companyPerformanceReviews.users);
            const sIndex = findIndex((e) => e.id === id.scorecard_id, draft.companyPerformanceReviews.users[uIndex].scorecards);
            const scorecard = clone(draft.companyPerformanceReviews.users[uIndex].scorecards[sIndex]);

            scorecard.quotas.forEach((item) => {
                const actual = find((e) => e.quota_id === item.id, response);
                const aIndex = findIndex((e) => e.id === actual?.id, item.actuals);
                if (actual) {
                    if (aIndex < 0) {
                        item.actuals.push(actual);
                    } else {
                        item.actuals[aIndex] = actual;
                    }
                }
            });
            draft.companyPerformanceReviews.users[uIndex].scorecards[sIndex] = scorecard;

            const ssIndex = findIndex((e) => e.id === id.scorecard_id, draft.individualPerformanceReview.scorecards);
            if (ssIndex < 0) return;
            const sscorecard = clone(draft.individualPerformanceReview.scorecards[ssIndex]);
            sscorecard.quotas = sscorecard.quotas.map((item) => {
                const actual = find((e) => e.quota_id === item.id, response);
                if (!actual) return item;
                const aIndex = findIndex((e) => e.id === actual?.id, item.actuals);
                if (aIndex < 0) {
                    item.actuals.push(actual);
                } else {
                    item.actuals[aIndex] = actual;
                }
                return item;
            });
            draft.individualPerformanceReview.scorecards[ssIndex] = sscorecard;
        }
    }
});
const postquotaactualsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mpq', draft.status);
});

const getanniversarybirthdayRequest = produce((draft, action) => {
    draft.status.push('pending-mgv');
});
const getanniversarybirthdaySuccess = produce((draft, action) => {
    const { active, prior, recruit } = action.response;
    draft.status = removeStatus('pending-mgv', draft.status);
    draft.anniversarybirthdayReport.active = active;
    draft.anniversarybirthdayReport.prior = prior;
    draft.anniversarybirthdayReport.recruit = recruit;
});
const getanniversarybirthdayFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mgv', draft.status);
});

const posttrainingreportsRequest = produce((draft, action) => {
    draft.status.push('pending-mtt');
});
const posttrainingreportsSuccess = produce((draft, action) => {
    const { response, target } = action;
    if (target === 'company') {
        const companies = sortBy(prop('name'), values(response.companies));
        draft.trainingReports.company = { ...response, companies };
    } else {
        const individuals = sortBy(prop('name'), values(response.individuals));
        draft.trainingReports.individual = { ...response, individuals };
    }
    draft.status = removeStatus('pending-mtt', draft.status);
});
const posttrainingreportsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mtt', draft.status);
});

const postquotaactualcommentRequest = produce((draft, action) => {
    draft.status.push('pending-mqc');
});
const postquotaactualcommentSuccess = produce((draft, action) => {
    const { response } = action;
    draft.individualPerformanceReview.scorecards = draft.individualPerformanceReview.scorecards.map((scorecard) => {
        scorecard.quotas = scorecard.quotas.map((item) => {
            if (item.actuals && item.actuals.length > 0) {
                const idx = findIndex((x) => x.id == response.id)(item.actuals);
                if (idx > -1) item.actuals[idx] = response;
            }
            return item;
        });
        return scorecard;
    });
    draft.status = removeStatus('pending-mqc', draft.status);
});
const postquotaactualcommentFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mqc', draft.status);
});

const postupdateactualcommentsRequest = produce((draft, action) => {
    draft.status.push('pending-muac');
});
const postupdateactualcommentsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-muac', draft.status);
});
const postupdateactualcommentsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-muac', draft.status);
});

const postsignoffRequest = produce((draft, action) => {
    draft.status.push('pending-mps');
});
const postsignoffSuccess = produce((draft, action) => {
    const { performance } = action.response;
    draft.status = removeStatus('pending-mps', draft.status);
    draft.individualPerformanceReview.performance.data.agreed = performance.data.agreed;
});
const postsignoffFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mps', draft.status);
});

const postquotareportRequest = produce((draft, action) => {
    draft.status.push('pending-mpr');
});
const postquotareportSuccess = produce((draft, action) => {
    draft.quotaReports = action.response;
    draft.status = removeStatus('pending-mpr', draft.status);
});
const postquotareportFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mpr', draft.status);
});

const posttrainingcompetencyreportRequest = produce((draft, action) => {
    draft.status.push('pending-mpm');
});
const posttrainingcompetencyreportSuccess = produce((draft, action) => {
    draft.trainingCompetencyReport = action.response;
    draft.status = removeStatus('pending-mpm', draft.status);
});
const posttrainingcompetencyreportFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mpm', draft.status);
});

const postterminateemployeeRequest = produce((draft, action) => {
    draft.status.push('pending-mpn');
});
const postterminateemployeeSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mpn', draft.status);
});
const postterminateemployeeFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mpn', draft.status);
});

const postindividualquotareportRequest = produce((draft, action) => {
    draft.status.push('pending-mph');
});
const postindividualquotareportSuccess = produce((draft, action) => {
    draft.individualQuotaReport = action.response;
    draft.status = removeStatus('pending-mph', draft.status);
});
const postindividualquotareportFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mph', draft.status);
});

const getquotasactualsRequest = produce((draft, action) => {
    draft.status.push('pending-mqa');
});
const getquotasactualsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mqa', draft.status);
});
const getquotasactualsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mqa', draft.status);
});

const getcompanyorgchartRequest = produce((draft, action) => {
    draft.status.push('pending-moc');
});
const getcompanyorgchartSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-moc', draft.status);
    draft.companyorgChart = action.response;
});
const getcompanyorgchartFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-moc', draft.status);
});

const getsaveactualsreportRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) {
        draft.status.push('pending-msr');
    }
});
const getsaveactualsreportSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-msr', draft.status);
    draft.saveactualsReport = action.response;
});
const getsaveactualsreportFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-msr', draft.status);
});

const getcheckoutactualsRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) {
        draft.status.push('pending-gca');
    }
});
const getcheckoutactualsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-gca', draft.status);
    draft.checkoutActuals = action.response;
});
const getcheckoutactualsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-gca', draft.status);
});

const getcheckoutorgchartRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) {
        draft.status.push('pending-gco');
    }
});
const getcheckoutorgchartSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-gco', draft.status);
    draft.checkoutActuals = action.response;
});
const getcheckoutorgchartFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-gco', draft.status);
});

const posttrainingtrackreportRequest = produce((draft, action) => {
    draft.status.push('pending-mtr');
});
const posttrainingtrackreportSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mtr', draft.status);
    draft.trainingTrackReport = action.response;
});
const posttrainingtrackreportFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mtr', draft.status);
});

const trainingtrackdetailreportRequest = produce((draft, action) => {
    draft.status.push('pending-mtd');
});
const trainingtrackdetailreportSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mtd', draft.status);
    draft.trainingTrackDetailReport = action.response;
});
const trainingtrackdetailreportFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mtd', draft.status);
});

const postteamactivityreportRequest = produce((draft, action) => {
    draft.status.push('pending-mta');
});
const postteamactivityreportSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-mta', draft.status);
    draft.teamActivityReport = action.response;
});
const postteamactivityreportFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mta', draft.status);
});

const postdeletescorecardRequest = produce((draft, action) => {
    draft.status.push('pending-dpd');
});
const postdeletescorecardSuccess = produce((draft, action) => {
    const { response } = action;
    draft.companyPerformanceReviews.users = draft.companyPerformanceReviews.users.map((item) => {
        if (item.scorecards.length > 0) {
            item.scorecards = filter((e) => response.scorecard.id !== e.id, item.scorecards);
            return item;
        }
        return item;
    });
    draft.companyDailyCheckouts.users = draft.companyDailyCheckouts.users.map((item) => {
        if (item.daily_scorecard?.id === response.scorecard.id) {
            item.daily_scorecard = null;
            return item;
        }
        return item;
    });
    draft.checkoutActuals.users = draft.checkoutActuals.users.map((item) => {
        if (item.checkout?.scorecard?.id === response.scorecard.id) {
            item.checkout.scorecard = null;
            return item;
        }
        return item;
    });
    draft.status = removeStatus('pending-dpd', draft.status);
});
const postdeletescorecardFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-dpd', draft.status);
});

const getdailyfeedRequest = produce((draft, action) => {
    draft.status.push('pending-mdr');
});
const getdailyfeedSuccess = produce((draft, action) => {
    const { all, month, today, week, daily_scorecard } = action.response;
    draft.dailyFeed = { all, month, today, week, daily_scorecard };
    draft.status = removeStatus('pending-mdr', draft.status);
});
const getdailyfeedFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-mdr', draft.status);
});

const getcheckoutRequest = produce((draft, action) => {
    draft.status.push('pending-gco');
});
const getcheckoutSuccess = produce((draft, action) => {
    draft.dailyCheckout = action.response;
    draft.status = removeStatus('pending-gco', draft.status);
});
const getcheckoutFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-gco', draft.status);
});

const postaddcheckoutcommentRequest = produce((draft, action) => {
    draft.status.push('pending-pac');
});
const postaddcheckoutcommentSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-pac', draft.status);
});
const postaddcheckoutcommentFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-pac', draft.status);
});

const postcheckouteditRequest = produce((draft, action) => {
    draft.status.push('pending-pce');
});
const postcheckouteditSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-pce', draft.status);
});
const postcheckouteditFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-pce', draft.status);
});

const postcheckoutsignoffRequest = produce((draft, action) => {
    draft.status.push('pending-pcso');
});
const postcheckoutsignoffSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-pcso', draft.status);
    draft.dailyCheckout.checkout = action.response.checkout;
});
const postcheckoutsignoffFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-pcso', draft.status);
});

const postcheckoutskipdayRequest = produce((draft, action) => {
    draft.status.push('pending-pcsd');
});
const postcheckoutskipdaySuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-pcsd', draft.status);
    draft.dailyCheckout.checkout = action.response.checkout;
});
const postcheckoutskipdayFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-pcsd', draft.status);
});

const postcheckoutresetRequest = produce((draft, action) => {
    draft.status.push('pending-pcr');
});
const postcheckoutresetSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-pcr', draft.status);
});
const postcheckoutresetFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-pcr', draft.status);
});

const postcheckoutapproveRequest = produce((draft, action) => {
    draft.status.push('pending-pca');
});
const postcheckoutapproveSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-pca', draft.status);
    draft.dailyCheckout.checkout = action.response.checkout;
});
const postcheckoutapproveFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-pca', draft.status);
});

const selectusersRequest = produce((draft, action) => {
    draft.currentUsers = action.payload;
});
const selectedprojectRequest = produce((draft, action) => {
    draft.currentProject = action.projectId;
});

const resetRequest = produce((draft) => {
    draft.status = [];
});

const clearRequest = produce((draft, action) => (draft = initialState));

export const reducer = createReducer(initialState, {
    [ManageTypes.POSTQUOTAREPORT_REQUEST]: postquotareportRequest,
    [ManageTypes.POSTQUOTAREPORT_SUCCESS]: postquotareportSuccess,
    [ManageTypes.POSTQUOTAREPORT_FAILURE]: postquotareportFailure,

    [ManageTypes.POSTTRAININGCOMPETENCYREPORT_REQUEST]: posttrainingcompetencyreportRequest,
    [ManageTypes.POSTTRAININGCOMPETENCYREPORT_SUCCESS]: posttrainingcompetencyreportSuccess,
    [ManageTypes.POSTTRAININGCOMPETENCYREPORT_FAILURE]: posttrainingcompetencyreportFailure,

    [ManageTypes.POSTTERMINATEEMPLOYEE_REQUEST]: postterminateemployeeRequest,
    [ManageTypes.POSTTERMINATEEMPLOYEE_SUCCESS]: postterminateemployeeSuccess,
    [ManageTypes.POSTTERMINATEEMPLOYEE_FAILURE]: postterminateemployeeFailure,

    [ManageTypes.POSTINDIVIDUALQUOTAREPORT_REQUEST]: postindividualquotareportRequest,
    [ManageTypes.POSTINDIVIDUALQUOTAREPORT_SUCCESS]: postindividualquotareportSuccess,
    [ManageTypes.POSTINDIVIDUALQUOTAREPORT_FAILURE]: postindividualquotareportFailure,

    [ManageTypes.GETQUOTASACTUALS_REQUEST]: getquotasactualsRequest,
    [ManageTypes.GETQUOTASACTUALS_SUCCESS]: getquotasactualsSuccess,
    [ManageTypes.GETQUOTASACTUALS_FAILURE]: getquotasactualsFailure,

    [ManageTypes.GETCAREERPROGRAM_REQUEST]: getcareerprogramRequest,
    [ManageTypes.GETCAREERPROGRAM_SUCCESS]: getcareerprogramSuccess,
    [ManageTypes.GETCAREERPROGRAM_FAILURE]: getcareerprogramFailure,

    [ManageTypes.POSTCAREERPROGRAM_REQUEST]: postcareerprogramRequest,
    [ManageTypes.POSTCAREERPROGRAM_SUCCESS]: postcareerprogramSuccess,
    [ManageTypes.POSTCAREERPROGRAM_FAILURE]: postcareerprogramFailure,

    [ManageTypes.GETTASKSFEED_REQUEST]: gettasksfeedRequest,
    [ManageTypes.GETTASKSFEED_SUCCESS]: gettasksfeedSuccess,
    [ManageTypes.GETTASKSFEED_FAILURE]: gettasksfeedFailure,

    [ManageTypes.COMPANYPROJECTS_REQUEST]: companyprojectsRequest,
    [ManageTypes.COMPANYPROJECTS_SUCCESS]: companyprojectsSuccess,
    [ManageTypes.COMPANYPROJECTS_FAILURE]: companyprojectsFailure,

    [ManageTypes.SELECTPROJECT_REQUEST]: selectprojectRequest,
    [ManageTypes.SELECTPROJECT_SUCCESS]: selectprojectSuccess,
    [ManageTypes.SELECTPROJECT_FAILURE]: selectprojectFailure,

    [ManageTypes.USERPROJECTTASK_REQUEST]: userprojecttaskRequest,
    [ManageTypes.USERPROJECTTASK_SUCCESS]: userprojecttaskSuccess,
    [ManageTypes.USERPROJECTTASK_FAILURE]: userprojecttaskFailure,

    [ManageTypes.ADDPROJECT_REQUEST]: addprojectRequest,
    [ManageTypes.ADDPROJECT_SUCCESS]: addprojectSuccess,
    [ManageTypes.ADDPROJECT_FAILURE]: addprojectFailure,

    [ManageTypes.ADDTASK_REQUEST]: addtaskRequest,
    [ManageTypes.ADDTASK_SUCCESS]: addtaskSuccess,
    [ManageTypes.ADDTASK_FAILURE]: addtaskFailure,

    [ManageTypes.UPDATEPROJECT_REQUEST]: updateprojectRequest,
    [ManageTypes.UPDATEPROJECT_SUCCESS]: updateprojectSuccess,
    [ManageTypes.UPDATEPROJECT_FAILURE]: updateprojectFailure,

    [ManageTypes.DELETEPROJECT_REQUEST]: deleteprojectRequest,
    [ManageTypes.DELETEPROJECT_SUCCESS]: deleteprojectSuccess,
    [ManageTypes.DELETEPROJECT_FAILURE]: deleteprojectFailure,

    [ManageTypes.UPDATETASK_REQUEST]: updatetaskRequest,
    [ManageTypes.UPDATETASK_SUCCESS]: updatetaskSuccess,
    [ManageTypes.UPDATETASK_FAILURE]: updatetaskFailure,

    [ManageTypes.EDITTASK_REQUEST]: edittaskRequest,
    [ManageTypes.EDITTASK_SUCCESS]: edittaskSuccess,
    [ManageTypes.EDITTASK_FAILURE]: edittaskFailure,

    [ManageTypes.DELETETASK_REQUEST]: deletetaskRequest,
    [ManageTypes.DELETETASK_SUCCESS]: deletetaskSuccess,
    [ManageTypes.DELETETASK_FAILURE]: deletetaskFailure,

    [ManageTypes.FETCHTASKDETAIL_REQUEST]: fetchtaskdetailRequest,
    [ManageTypes.FETCHTASKDETAIL_SUCCESS]: fetchtaskdetailSuccess,
    [ManageTypes.FETCHTASKDETAIL_FAILURE]: fetchtaskdetailFailure,

    [ManageTypes.ADDMNGCOMMENT_REQUEST]: addmngcommentRequest,
    [ManageTypes.ADDMNGCOMMENT_SUCCESS]: addmngcommentSuccess,
    [ManageTypes.ADDMNGCOMMENT_FAILURE]: addmngcommentFailure,

    [ManageTypes.FETCHPROJECTSDETAIL_REQUEST]: fetchprojectsdetailRequest,
    [ManageTypes.FETCHPROJECTSDETAIL_SUCCESS]: fetchprojectsdetailSuccess,
    [ManageTypes.FETCHPROJECTSDETAIL_FAILURE]: fetchprojectsdetailFailure,
    [ManageTypes.FETCHPROJECTDETAIL_COMPLETE]: fetchprojectdetailComplete,

    [ManageTypes.SEARCHMODULES_REQUEST]: searchmodulesRequest,
    [ManageTypes.SEARCHMODULES_SUCCESS]: searchmodulesSuccess,
    [ManageTypes.SEARCHMODULES_FAILURE]: searchmodulesFailure,

    [ManageTypes.ASSIGNTRAINING_REQUEST]: assigntrainingRequest,
    [ManageTypes.ASSIGNTRAINING_SUCCESS]: assigntrainingSuccess,
    [ManageTypes.ASSIGNTRAINING_FAILURE]: assigntrainingFailure,

    [ManageTypes.ASSIGNCOURSES_REQUEST]: assigncoursesRequest,
    [ManageTypes.ASSIGNCOURSES_SUCCESS]: assigncoursesSuccess,
    [ManageTypes.ASSIGNCOURSES_FAILURE]: assigncoursesFailure,

    [ManageTypes.UNASSIGNCONTENT_REQUEST]: unassigncontentRequest,
    [ManageTypes.UNASSIGNCONTENT_SUCCESS]: unassigncontentSuccess,
    [ManageTypes.UNASSIGNCONTENT_FAILURE]: unassigncontentFailure,

    [ManageTypes.COMPANYINDIVIDUAL_REQUEST]: companyindividualRequest,
    [ManageTypes.COMPANYINDIVIDUAL_SUCCESS]: companyindividualSuccess,
    [ManageTypes.COMPANYINDIVIDUAL_FAILURE]: companyindividualFailure,

    [ManageTypes.FETCHENGAGEMENTREPORT_REQUEST]: fetchengagementreportRequest,
    [ManageTypes.FETCHENGAGEMENTREPORT_SUCCESS]: fetchengagementreportSuccess,
    [ManageTypes.FETCHENGAGEMENTREPORT_FAILURE]: fetchengagementreportFailure,

    [ManageTypes.FETCHCOMPANYCAREERS_REQUEST]: fetchcompanycareersRequest,
    [ManageTypes.FETCHCOMPANYCAREERS_SUCCESS]: fetchcompanycareersSuccess,
    [ManageTypes.FETCHCOMPANYCAREERS_FAILURE]: fetchcompanycareersFailure,

    [ManageTypes.FETCHCERTIFICATIONSREPORT_REQUEST]: fetchcertificationsreportRequest,
    [ManageTypes.FETCHCERTIFICATIONSREPORT_SUCCESS]: fetchcertificationsreportSuccess,
    [ManageTypes.FETCHCERTIFICATIONSREPORT_FAILURE]: fetchcertificationsreportFailure,

    [ManageTypes.FETCHCAREERREPORTS_REQUEST]: fetchcareerreportsRequest,
    [ManageTypes.FETCHCAREERREPORTS_SUCCESS]: fetchcareerreportsSuccess,
    [ManageTypes.FETCHCAREERREPORTS_FAILURE]: fetchcareerreportsFailure,

    [ManageTypes.GETANNIVERSARYBIRTHDAY_REQUEST]: getanniversarybirthdayRequest,
    [ManageTypes.GETANNIVERSARYBIRTHDAY_SUCCESS]: getanniversarybirthdaySuccess,
    [ManageTypes.GETANNIVERSARYBIRTHDAY_FAILURE]: getanniversarybirthdayFailure,

    [ManageTypes.FETCHHIREORIENTATIONREPORT_REQUEST]: fetchhireorientationreportRequest,
    [ManageTypes.FETCHHIREORIENTATIONREPORT_SUCCESS]: fetchhireorientationreportSuccess,
    [ManageTypes.FETCHHIREORIENTATIONREPORT_FAILURE]: fetchhireorientationreportFailure,

    [ManageTypes.COMPANYPERFORMANCEREVIEWS_REQUEST]: companyperformancereviewsRequest,
    [ManageTypes.COMPANYPERFORMANCEREVIEWS_SUCCESS]: companyperformancereviewsSuccess,
    [ManageTypes.COMPANYPERFORMANCEREVIEWS_FAILURE]: companyperformancereviewsFailure,

    [ManageTypes.COMPANYPERFORMANCEREVIEWSSTATS_REQUEST]: companyperformancereviewsstatsRequest,
    [ManageTypes.COMPANYPERFORMANCEREVIEWSSTATS_SUCCESS]: companyperformancereviewsstatsSuccess,
    [ManageTypes.COMPANYPERFORMANCEREVIEWSSTATS_FAILURE]: companyperformancereviewsstatsFailure,

    [ManageTypes.COMPANYDAILYCHECKOUTS_REQUEST]: companydailycheckoutsRequest,
    [ManageTypes.COMPANYDAILYCHECKOUTS_SUCCESS]: companydailycheckoutsSuccess,
    [ManageTypes.COMPANYDAILYCHECKOUTS_FAILURE]: companydailycheckoutsFailure,

    [ManageTypes.INDIVIDUALPERFORMANCEREVIEW_REQUEST]: individualperformancereviewRequest,
    [ManageTypes.INDIVIDUALPERFORMANCEREVIEW_SUCCESS]: individualperformancereviewSuccess,
    [ManageTypes.INDIVIDUALPERFORMANCEREVIEW_FAILURE]: individualperformancereviewFailure,

    [ManageTypes.POSTPERFORMANCEREVIEW_REQUEST]: postperformancereviewRequest,
    [ManageTypes.POSTPERFORMANCEREVIEW_SUCCESS]: postperformancereviewSuccess,
    [ManageTypes.POSTPERFORMANCEREVIEW_FAILURE]: postperformancereviewFailure,

    [ManageTypes.POSTPERFORMANCEREVIEWRESET_REQUEST]: postperformancereviewresetRequest,
    [ManageTypes.POSTPERFORMANCEREVIEWRESET_SUCCESS]: postperformancereviewresetSuccess,
    [ManageTypes.POSTPERFORMANCEREVIEWRESET_FAILURE]: postperformancereviewresetFailure,

    [ManageTypes.GETPERFORMANCEREVIEWS_REQUEST]: getperformancereviewsRequest,
    [ManageTypes.GETPERFORMANCEREVIEWS_SUCCESS]: getperformancereviewsSuccess,
    [ManageTypes.GETPERFORMANCEREVIEWS_FAILURE]: getperformancereviewsFailure,

    [ManageTypes.GETPREVIOUSREVIEWTASKS_REQUEST]: getpreviousreviewtasksRequest,
    [ManageTypes.GETPREVIOUSREVIEWTASKS_SUCCESS]: getpreviousreviewtasksSuccess,
    [ManageTypes.GETPREVIOUSREVIEWTASKS_FAILURE]: getpreviousreviewtasksFailure,

    [ManageTypes.GETMANAGERDASHBOARD_REQUEST]: getmanagerdashboardRequest,
    [ManageTypes.GETMANAGERDASHBOARD_SUCCESS]: getmanagerdashboardSuccess,
    [ManageTypes.GETMANAGERDASHBOARD_FAILURE]: getmanagerdashboardFailure,

    [ManageTypes.POSTQUOTAACTUALS_REQUEST]: postquotaactualsRequest,
    [ManageTypes.POSTQUOTAACTUALS_SUCCESS]: postquotaactualsSuccess,
    [ManageTypes.POSTQUOTAACTUALS_FAILURE]: postquotaactualsFailure,

    [ManageTypes.POSTTRAININGREPORTS_REQUEST]: posttrainingreportsRequest,
    [ManageTypes.POSTTRAININGREPORTS_SUCCESS]: posttrainingreportsSuccess,
    [ManageTypes.POSTTRAININGREPORTS_FAILURE]: posttrainingreportsFailure,

    [ManageTypes.POSTQUOTAACTUALCOMMENT_REQUEST]: postquotaactualcommentRequest,
    [ManageTypes.POSTQUOTAACTUALCOMMENT_SUCCESS]: postquotaactualcommentSuccess,
    [ManageTypes.POSTQUOTAACTUALCOMMENT_FAILURE]: postquotaactualcommentFailure,

    [ManageTypes.POSTUPDATEACTUALCOMMENTS_REQUEST]: postupdateactualcommentsRequest,
    [ManageTypes.POSTUPDATEACTUALCOMMENTS_SUCCESS]: postupdateactualcommentsSuccess,
    [ManageTypes.POSTUPDATEACTUALCOMMENTS_FAILURE]: postupdateactualcommentsFailure,

    [ManageTypes.POSTSIGNOFF_REQUEST]: postsignoffRequest,
    [ManageTypes.POSTSIGNOFF_SUCCESS]: postsignoffSuccess,
    [ManageTypes.POSTSIGNOFF_FAILURE]: postsignoffFailure,

    [ManageTypes.GETCOMPANYORGCHART_REQUEST]: getcompanyorgchartRequest,
    [ManageTypes.GETCOMPANYORGCHART_SUCCESS]: getcompanyorgchartSuccess,
    [ManageTypes.GETCOMPANYORGCHART_FAILURE]: getcompanyorgchartFailure,

    [ManageTypes.GETSAVEACTUALSREPORT_REQUEST]: getsaveactualsreportRequest,
    [ManageTypes.GETSAVEACTUALSREPORT_SUCCESS]: getsaveactualsreportSuccess,
    [ManageTypes.GETSAVEACTUALSREPORT_FAILURE]: getsaveactualsreportFailure,

    [ManageTypes.GETCHECKOUTACTUALS_REQUEST]: getcheckoutactualsRequest,
    [ManageTypes.GETCHECKOUTACTUALS_SUCCESS]: getcheckoutactualsSuccess,
    [ManageTypes.GETCHECKOUTACTUALS_FAILURE]: getcheckoutactualsFailure,

    [ManageTypes.GETCHECKOUTORGCHART_REQUEST]: getcheckoutorgchartRequest,
    [ManageTypes.GETCHECKOUTORGCHART_SUCCESS]: getcheckoutorgchartSuccess,
    [ManageTypes.GETCHECKOUTORGCHART_FAILURE]: getcheckoutorgchartFailure,

    [ManageTypes.POSTTRAININGTRACKREPORT_REQUEST]: posttrainingtrackreportRequest,
    [ManageTypes.POSTTRAININGTRACKREPORT_SUCCESS]: posttrainingtrackreportSuccess,
    [ManageTypes.POSTTRAININGTRACKREPORT_FAILURE]: posttrainingtrackreportFailure,

    [ManageTypes.TRAININGTRACKDETAILREPORT_REQUEST]: trainingtrackdetailreportRequest,
    [ManageTypes.TRAININGTRACKDETAILREPORT_SUCCESS]: trainingtrackdetailreportSuccess,
    [ManageTypes.TRAININGTRACKDETAILREPORT_FAILURE]: trainingtrackdetailreportFailure,

    [ManageTypes.POSTTEAMACTIVITYREPORT_REQUEST]: postteamactivityreportRequest,
    [ManageTypes.POSTTEAMACTIVITYREPORT_SUCCESS]: postteamactivityreportSuccess,
    [ManageTypes.POSTTEAMACTIVITYREPORT_FAILURE]: postteamactivityreportFailure,

    [ManageTypes.POSTDELETESCORECARD_REQUEST]: postdeletescorecardRequest,
    [ManageTypes.POSTDELETESCORECARD_SUCCESS]: postdeletescorecardSuccess,
    [ManageTypes.POSTDELETESCORECARD_FAILURE]: postdeletescorecardFailure,

    [ManageTypes.GETDAILYFEED_REQUEST]: getdailyfeedRequest,
    [ManageTypes.GETDAILYFEED_SUCCESS]: getdailyfeedSuccess,
    [ManageTypes.GETDAILYFEED_FAILURE]: getdailyfeedFailure,

    [ManageTypes.GETCHECKOUT_REQUEST]: getcheckoutRequest,
    [ManageTypes.GETCHECKOUT_SUCCESS]: getcheckoutSuccess,
    [ManageTypes.GETCHECKOUT_FAILURE]: getcheckoutFailure,

    [ManageTypes.POSTADDCHECKOUTCOMMENT_REQUEST]: postaddcheckoutcommentRequest,
    [ManageTypes.POSTADDCHECKOUTCOMMENT_SUCCESS]: postaddcheckoutcommentSuccess,
    [ManageTypes.POSTADDCHECKOUTCOMMENT_FAILURE]: postaddcheckoutcommentFailure,

    [ManageTypes.POSTCHECKOUTEDIT_REQUEST]: postcheckouteditRequest,
    [ManageTypes.POSTCHECKOUTEDIT_SUCCESS]: postcheckouteditSuccess,
    [ManageTypes.POSTCHECKOUTEDIT_FAILURE]: postcheckouteditFailure,

    [ManageTypes.POSTCHECKOUTSIGNOFF_REQUEST]: postcheckoutsignoffRequest,
    [ManageTypes.POSTCHECKOUTSIGNOFF_SUCCESS]: postcheckoutsignoffSuccess,
    [ManageTypes.POSTCHECKOUTSIGNOFF_FAILURE]: postcheckoutsignoffFailure,

    [ManageTypes.POSTCHECKOUTSKIPDAY_REQUEST]: postcheckoutskipdayRequest,
    [ManageTypes.POSTCHECKOUTSKIPDAY_SUCCESS]: postcheckoutskipdaySuccess,
    [ManageTypes.POSTCHECKOUTSKIPDAY_FAILURE]: postcheckoutskipdayFailure,

    [ManageTypes.POSTCHECKOUTRESET_REQUEST]: postcheckoutresetRequest,
    [ManageTypes.POSTCHECKOUTRESET_SUCCESS]: postcheckoutresetSuccess,
    [ManageTypes.POSTCHECKOUTRESET_FAILURE]: postcheckoutresetFailure,

    [ManageTypes.POSTCHECKOUTAPPROVE_REQUEST]: postcheckoutapproveRequest,
    [ManageTypes.POSTCHECKOUTAPPROVE_SUCCESS]: postcheckoutapproveSuccess,
    [ManageTypes.POSTCHECKOUTAPPROVE_FAILURE]: postcheckoutapproveFailure,

    [ManageTypes.SELECTUSERS_REQUEST]: selectusersRequest,
    [ManageTypes.SELECTEDPROJECT_REQUEST]: selectedprojectRequest,
    [ManageTypes.RESET_REQUEST]: resetRequest,
    [ManageTypes.CLEAR_REQUEST]: clearRequest,

    [ManageTypes.GETCOMPANYCHECKOUTS_REQUEST]: getcompanycheckoutsRequest,
    [ManageTypes.GETCOMPANYCHECKOUTS_SUCCESS]: getcompanycheckoutsSuccess,
    [ManageTypes.GETCOMPANYCHECKOUTS_FAILURE]: getcompanycheckoutsFailure,
});
